import { widgetPageListPath } from '@/common/app/path'
import { useSiteId } from '@/common/app/site'
import { WidgetPage } from '@/common/model/recommend/widgetPage'

import BackButton from '@/components/view/atoms/button/BackButton'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'

import WidgetPageForm from '@/components/container/form/modules/recommend/widgetPage/WidgetPageForm'

interface Props {
  widgetPage?: WidgetPage
  onRefetch?: () => void
}

const WidgetPageEditPage = ({ widgetPage, onRefetch }: Props) => {
  const siteId = useSiteId()
  return (
    <Main type={MainLayoutType.SMALL}>
      <BackButton link={widgetPageListPath(siteId)} />
      <WidgetPageForm widgetPage={widgetPage} onRefetch={onRefetch} />
    </Main>
  )
}

export default WidgetPageEditPage
